import { memo } from "react";

import { Checkbox } from "@/components/ui/input/checkbox";

import type { InSaleAndStopSellingItemsType } from "../../../type";
import type { CheckedState } from "@radix-ui/react-checkbox";

type CheckboxListProps = {
	items: InSaleAndStopSellingItemsType;
	selectedItemIDs: string[];
	isPending: boolean;
	onCheckedChange: (params: { checked: CheckedState; id: string }) => void;
};

export const CheckboxList = memo(({ items, selectedItemIDs, isPending, onCheckedChange }: CheckboxListProps) => {
	return (
		<div className="grid grid-cols-3 gap-x-4 gap-y-2">
			{items.map((item, idx) => (
				<div
					key={`${item.id}_${idx}`}
					className="col-span-1 flex items-center gap-x-2 text-sm first:col-span-3"
				>
					<Checkbox
						id={item.id}
						disabled={isPending}
						checked={selectedItemIDs.includes(item.id)}
						onCheckedChange={(checked) => {
							onCheckedChange({ checked, id: item.id });
						}}
					/>
					<label htmlFor={item.id}>{item.name}</label>
				</div>
			))}
		</div>
	);
});

CheckboxList.displayName = "CheckboxList";
